<script>
  import SalesPitch from '$lib/teach/SalesPitch.svelte';
  import Tagline from '$lib/teach/Tagline.svelte';
</script>

<div class="wrapper mt-2 mb-8">
  <div class="margins page-content">
    <slot />
    <SalesPitch />
  </div>
</div>
<Tagline class="pt-12" />
